/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 ..\EG.glb --transform 
Files: ..\EG.glb [15.53MB] > C:\Users\fabia\OneDrive\Dokumente\Dateien\To-Do\IDPA_BM-Campus\glb\gltfjsx\EG-transformed.glb [486.84KB] (97%)
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'

export function EGModel(props) {
  const { nodes, materials } = useGLTF('/models/EG-transformed.glb')
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.EG.geometry} material={materials['Benutzerdefiniert (4)']} position={[-10, 0, -18.5]} rotation={[Math.PI / 2, 0, 0]} scale={0.001} />
    </group>
  )
}

useGLTF.preload('/models/EG-transformed.glb')
